import { render, staticRenderFns } from "./ApprovalOfSettlementInstructions.vue?vue&type=template&id=544744f0&scoped=true&"
import script from "./ApprovalOfSettlementInstructions.vue?vue&type=script&lang=js&"
export * from "./ApprovalOfSettlementInstructions.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalOfSettlementInstructions.vue?vue&type=style&index=0&id=544744f0&scoped=true&lang=css&"
import style1 from "./ApprovalOfSettlementInstructions.vue?vue&type=style&index=1&id=544744f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544744f0",
  null
  
)

export default component.exports